export function getRandomKey() {
    return Math.random().toString(36).substring(2);
}

export function isFunction(value: unknown) {
    return typeof value === 'function';
}

export function isAscii(value: string): boolean {
    // eslint-disable-next-line no-control-regex
    return /^[\x00-\x7F]*$/.test(value);
}

type NullUndefined = null | undefined;
export const isNullUndefined = (value: unknown): value is NullUndefined =>
    value === null || value === undefined;
